import React from 'react'

import DetailsClientPricingItemSections from '../proposal/proposal-details/details-container/detail-billing-sections/DetailsClientPricingItemSections'
import {
  ClientPricingItemFragment,
  SeasonEnum,
  ServiceProviderCategoryEnum,
} from '../../../lib/graphql'

const HouseOwnerPricesCard = ({
  clientPricingItems,
}: {
  clientPricingItems: ClientPricingItemFragment[]
}) => {
  const houseClientPricingItems = clientPricingItems
    .filter((item) => item.category === ServiceProviderCategoryEnum.HOUSE)
    .sort((a: ClientPricingItemFragment, b: ClientPricingItemFragment) => {
      const seasonValues = {
        [SeasonEnum.LOW]: 1,
        [SeasonEnum.MEDIUM]: 2,
        [SeasonEnum.HIGH]: 3,
      }

      return a.season && b.season
        ? seasonValues[a.season] - seasonValues[b.season]
        : 0
    })

  const batchProvisionClientPricingItems = clientPricingItems.filter(
    (item) => item.category === ServiceProviderCategoryEnum.BATCH_PROVISIONS,
  )

  const restaurationClientPricingItems = clientPricingItems.filter(
    (item) => item.category === ServiceProviderCategoryEnum.RESTAURATION,
  )

  const activityClientPricingItems = clientPricingItems.filter(
    (item) => item.category === ServiceProviderCategoryEnum.ACTIVITY,
  )

  const mobilityClientPricingItems = clientPricingItems.filter(
    (item) => item.category === ServiceProviderCategoryEnum.TRANSPORT,
  )

  return (
    <DetailsClientPricingItemSections
      clientPricingItemSections={{
        batchProvisionClientPricingItems,
        houseClientPricingItems,
        restaurationClientPricingItems,
        activityClientPricingItems,
        mobilityClientPricingItems,
      }}
    />
  )
}

export default HouseOwnerPricesCard
